import { render, staticRenderFns } from "./ROAInput.vue?vue&type=template&id=5342ef19&"
import script from "./ROAInput.vue?vue&type=script&lang=js&"
export * from "./ROAInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports